import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { ReactComponent as TriangleSvg } from '../../assets/svg/triangle.svg';
import { ReactComponent as UploadSvg } from '../../assets/svg/upload.svg';
import { ReactComponent as DeleteSvg } from '../../assets/svg/delete.svg';
import { ReactComponent as AddSvg } from '../../assets/svg/add.svg';

import { ReactComponent as ZoomInSvg } from '../../assets/svg/zoom-in.svg';
import { ReactComponent as ZoomOutSvg } from '../../assets/svg/zoom-out.svg';
import { ReactComponent as RemoveSvg } from '../../assets/svg/remove.svg';

// import GoodPng from '../../assets/images/goods.png';
// import GoodLayoutPng from '../../assets/images/good-layout.png';
import BodyLayoutPng from '../../assets/images/body-layout.png';
import HeaderLayoutPng from '../../assets/images/header-layout.png';
import BottomLayoutPng from '../../assets/images/bottom-layout.png';

import { ReactComponent as ChosedSvg } from '../../assets/svg/chosed-triangle.svg';
import { message, Modal, Spin } from 'antd';
import BorderBox from '../BorderBox/index.jsx';
import PreviewWin from '../PreviewWin/index.jsx';
import { useRoot } from '../../hooks/useRoot.jsx';
import { delProjectImg, getAllImgByProId, getImageurl, getImgUrl, previewLayout, putImgToProject, transferimageToPlanogram, uploadImg } from '../../api/request.js';
import { LoadingOutlined } from '@ant-design/icons';
import { PCIMGARY } from '../../utils/utils.ts';

import html2canvas from 'html2canvas';

const GenerateLayout = () => {
  const [ showPreview, setShowPreview ] = useState(false);
  const [ showUpload, setShowUpload ] = useState(false);
  const tableBoxRef = useRef(null);
  const [ base64Img, setBase64Img ] = useState('');

  const [ allImgs, setAllImgs ] = useState([]);
  const { otherProId, curProId, curLayoutId, thirdDB, setOtherProId, setThirdDB, setShowDatabaseWin } = useRoot();
  const [ loading, setLoading ] = useState(false);
  const [ isLayoutUpload, setIsLayoutUpload ] = useState(false);

  const [ curRowCol, setCurRowCol ] = useState({
    row: -1,
    col: -1,
  });

  const fnDragStart = (drageData) => {
    const target = drageData.target;
    drageData.dataTransfer.setData('text/plain', target.dataset.imginfo);
  };

  const getAllImgs = useCallback(async () => {
    try {
      if(!curProId) return;
      const result = await getAllImgByProId(curProId, true);
      if(result.status === 'Success') {
        setAllImgs(result.data);
      }
    } catch(error) {
      console.error('Error fetching images:', error);
    }
  }, [curProId]);

  const getOtherProImgs = useCallback(async () => {
    try {
      if(!otherProId) return;
      if(otherProId === '9999') return;
      setLoading(true);
      let result;
      if(thirdDB === 'screening') {
        result = await transferimageToPlanogram(otherProId);
      } else {
        result = await getAllImgByProId(otherProId, true);
      }
      if(result.status === 'Success') {
        if(!isLayoutUpload) {
          // 
        } else {
          let imgList = [];
          if(thirdDB === 'screening') {
            imgList = result.data.map(item => {
              return {
                id: item.imageid,
                url: item.imagepath
              };
            });
          } else {
            imgList = result.data;
          }
          if(tableBoxRef.current) {
            tableBoxRef.current.thirdImportImg(curRowCol.row, curRowCol.col, imgList);
          }
        }

        let ids = [];
        if(thirdDB === 'screening') {
          ids = result.data.map(item => item.imageid);
        } else {
          ids = result.data.map(item => item.id);
        }
        await putImgToProject(curProId, {
          imageids: ids,
        });
        getAllImgs();
      }
    } catch(error) {
      console.error('Error fetching other project images:', error);
    } finally {
      setLoading(false);
      setOtherProId('');
    }
  }, [otherProId, curProId, thirdDB]);

  useEffect(() => {
    getOtherProImgs();
  }, [getOtherProImgs]);

  useEffect(() => {
    getAllImgs();
  }, [getAllImgs]);

  useEffect(() => {
    if(tableBoxRef.current) {
      const imgAry = JSON.parse(sessionStorage.getItem(PCIMGARY)) || [];
      if(imgAry.length) {
        tableBoxRef.current.setOldLayout(imgAry);
      }
    }
  }, [tableBoxRef]);

  const fnOpenUploadWin = () => {
    setIsLayoutUpload(false);
    setShowUpload(true);
  };

  const fnOpenUploadWinByLayout = (rowIndex = -1, colIndex = -1) => {
    setIsLayoutUpload(true);
    setCurRowCol({
      row: rowIndex,
      col: colIndex,
    });
    setShowUpload(true);
  };

  const fnFileUpload = async (event) => {
    try {
      setLoading(true);
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      setShowUpload(false);
      const result = await uploadImg(formData);
      if(result.status === 'Success') {
        // 资源库上传
        if(!isLayoutUpload) {
          // 
        } else {
          // 货架上传
          if(curRowCol.row > -1 && curRowCol.col > -1) {
            const imgUrlResult = await getImgUrl(result.data.imagepath);
            if(imgUrlResult.status === 'Success') {
              if(tableBoxRef.current) {
                tableBoxRef.current.addNew(curRowCol.row, curRowCol.col, JSON.stringify({
                  url: imgUrlResult.data.url,
                  id: result.data.imageid
                }));
              }
            }
          }
        }

        await putImgToProject(curProId, {
          imageids: [result.data.imageid],
        });
        await getAllImgs();
      }
    } catch(error) {
      console.error('Error uploading file:', error);
      return;
    } finally {
      // 清空 input 的值，避免重复上传同一文件
      event.target.files = null; 
      setTimeout(() => {
        event.target.files = null; 
      }, 0);
      setLoading(false);
    }
  };

  const fnDeleteImg = async (id) => {
    try {
      setLoading(true);
      const params = {
        imageids: id === 'all' ? 'all'  : [id]
      };
      const result = await delProjectImg(curProId, params);
      if(result.status === 'Success') {
        await getAllImgs();
      }
    } catch(error) {
      console.error('Error deleting image:', error);
    } finally {
      setLoading(false);
    }
  };

  const fnCleanAll = () => {
    if(tableBoxRef.current) {
      tableBoxRef.current.cleanAll();
      sessionStorage.removeItem(PCIMGARY);
    }
  };

  // const fnOpenReviewWin = async () => {
  //   try {
  //     if(tableBoxRef.current) {
  //       setLoading(true);
  //       const imageids = [];
  //       const zooms = [];
  //       const imgAry = tableBoxRef.current.imgAry;
  //       imgAry.forEach((rowItem) => {
  //         const colImageIds = [];
  //         const colZooms = [];
  //         rowItem.forEach((colItem) => {
  //           if(colItem === 0) {
  //             colImageIds.push(0);
  //             colZooms.push(0);
  //           } else {
  //             const { id, zoom } = colItem;
  //             colImageIds.push(id);
  //             colZooms.push(zoom);
  //           }
  //         });
  //         imageids.push(colImageIds);
  //         zooms.push(colZooms);
  //       });
  //       const params = {
  //         layoutid: curLayoutId,
  //         imageids,
  //         zooms
  //       };
  //       const result = await previewLayout(params);
  //       if(result.status === 'Success') {
  //         // const imgBase64 =  `data:image/png;base64,${result.data.preview}`;
  //         // setBase64Img(imgBase64);
  //         // setShowPreview(true);
  //         // sessionStorage.setItem(PCIMGARY, JSON.stringify(imgAry));
  //       }
  //     }
  //   } catch(error) {
  //     console.error('Error opening review window:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const [aryData, setAryData] = useState([]);
  // const fnGenerateImg = () => {
  //   const imgAry = tableBoxRef.current.imgAry;
  //   setAryData(imgAry);
  //   setTimeout(() => {
  //     html2canvas(document.getElementById('goods_layout_id'), {
  //       backgroundColor: null,
  //       scale: 2,
  //       useCORS: true
  //     }).then(canvas => {
  //       // const link = document.createElement('a');
  //       // link.download = 'screenshot.png';
  //       // link.href = canvas.toDataURL('image/png');
  //       // link.click();
  //       const imgPreviewUrl = canvas.toDataURL('image/png');

  //       setBase64Img(imgPreviewUrl);
  //       setShowPreview(true);
  //       sessionStorage.setItem(PCIMGARY, JSON.stringify(imgAry));
  //     });
  //   }, 2000);
  // };

  const fnOpenReviewWin = async () => {
    try {
      if(tableBoxRef.current) {
        setLoading(true);
        const imgAry = tableBoxRef.current.imgAry;
        setAryData(imgAry);
        // 渲染图片
        setTimeout(() => {
          html2canvas(document.getElementById('goods_layout_id'), {
            backgroundColor: null,
            scale: 2,
            useCORS: true
          }).then(async (canvas) => {
            const imageids = [];
            const zooms = [];
            imgAry.forEach((rowItem) => {
              const colImageIds = [];
              const colZooms = [];
              rowItem.forEach((colItem) => {
                if(colItem === 0) {
                  colImageIds.push(0);
                  colZooms.push(0);
                } else {
                  const { id, zoom } = colItem;
                  colImageIds.push(id);
                  colZooms.push(zoom);
                }
              });
              imageids.push(colImageIds);
              zooms.push(colZooms);
            });
            const params = {
              layoutid: curLayoutId,
              imageids,
              zooms
            };
            const result = await previewLayout(params);
            if(result.status === 'Success') {
              const imgPreviewUrl = canvas.toDataURL('image/png');
              setBase64Img(imgPreviewUrl);
              setShowPreview(true);
              sessionStorage.setItem(PCIMGARY, JSON.stringify(imgAry));
            }
            setLoading(false);
          });
        }, 2000);
      }
    } catch(error) {
      console.error('Error opening review window:', error);
    }
  };

  return <>
    <Spin spinning={loading} indicator={<LoadingOutlined spin color='#00A32E' />} size="large" fullscreen />
    <div className='flex-1 flex mb-5 h-0'>
      <div id="table_box_1" className='w-[360px] min-w-[360px] mr-6 bg-[#09170C] flex flex-col h-full'>
        <div className='h-[50px] bg-[#008228] rounded flex justify-between items-center px-3'>
          <div className='flex justify-between items-center'>
            <TriangleSvg></TriangleSvg>
            <span className='text-base text-white ml-2'>Add Your Packs</span>
          </div>

          <div className='flex justify-between items-center'>
            <DeleteSvg className="mr-2 cursor-pointer fill-white" onClick={() => fnDeleteImg('all')}></DeleteSvg>
            <div onClick={fnOpenUploadWin} className='flex items-center border rounded-[23px] border-white h-[28px] px-[10px] cursor-pointer'>
              <UploadSvg></UploadSvg>
              <span className='ml-1'>Upload</span>
            </div>
          </div>
        </div>
        <div className='overflow-y-auto mt-3 flex-1 h-0' style={{userSelect: 'none'}}>
          <div className='flex justify-center'>
            <div onDragStart={fnDragStart} className='grid grid-cols-3 grid-rows-none gap-2'>
              {
                allImgs.map((item, index) => <ImageCom key={index} detail={item} onDelete={() => fnDeleteImg(item.id)}></ImageCom>)
              }
              {
                (new Array( allImgs.length > 14 ? 0 : 14 -  allImgs.length).fill(1)).map((item, index) => <UploadImgCom onClick={fnOpenUploadWin} key={index}></UploadImgCom>)
              }
              {
                <UploadImgCom onClick={fnOpenUploadWin}></UploadImgCom>
              }
            </div>
          </div>
        </div>
      </div> 
      <div className='flex-1 flex flex-col'>
        <div className='flex-1 mb-3' onDragStart={fnDragStart}>
          <TableBoxView ref={tableBoxRef} onUpload={fnOpenUploadWinByLayout}></TableBoxView>
        </div>
        <div className='flex justify-between items-center'>
          <div onClick={fnCleanAll} className='cursor-pointer border border-white rounded-[23px] px-8 h-[35px] flex justify-center items-center'>
            <span className='text-base'>Clean all</span>
          </div>
          <div onClick={fnOpenReviewWin} className='bg-btn flex justify-center items-center'>
            <span className='text-lg font-bold leading-none'>PREVIEW</span>
          </div>
        </div>
      </div>
    </div>

    <Modal
      open={showUpload}
      closable={false}
      footer={null}
      centered
      width={300}
      classNames={{
        content: '!p-0 !bg-[#000000]',
      }}
      onCancel={() => setShowUpload(false)}
    >
      <BorderBox isSmall={true}>
        <div className='px-[25px] py-[20px] text-white relative z-10'>
          <div className='flex justify-start items-center group text-[14px] cursor-pointer relative'>
            <ChosedSvg className="opacity-0 group-hover:opacity-100"></ChosedSvg>
            <div className='ml-3 group-hover:text-[#00A32E]'>Upload from my laptop</div>
            <input onChange={fnFileUpload} type="file" accept="image/*"  className=' absolute top-0 left-0 cursor-pointer opacity-0'/>
          </div>
          <div onClick={() => {
            setThirdDB('self');
            setShowDatabaseWin(true);
            setShowUpload(false);
          }} className='flex justify-center items-center group text-[14px] my-3 cursor-pointer'>
            <ChosedSvg className="opacity-0 group-hover:opacity-100"></ChosedSvg>
            <div className='ml-3 group-hover:text-[#00A32E]'>Import from Shelf Visibility Check database</div>
          </div>
          <div onClick={() => {
            setThirdDB('screening');
            setShowDatabaseWin(true);
            setShowUpload(false);
          }} className='flex justify-center items-center group text-[14px] cursor-pointer'>
            <ChosedSvg className="opacity-0 group-hover:opacity-100"></ChosedSvg>
            <div className='ml-3 group-hover:text-[#00A32E]'>Import from Pack Screening database</div>
          </div>
        </div>
      </BorderBox>
    </Modal>

    <PreviewWin show={showPreview} imgurl={base64Img} onClose={setShowPreview}></PreviewWin>

    <CanvasTableBox aryData={aryData}></CanvasTableBox>
  </>;
};

const UploadImgCom = ({onClick}) => {
  return <div onClick={onClick} className='cursor-pointer w-[100px] h-[100px] bg-[#082C11] border border-[#00A32E80] rounded-xl flex justify-center items-center'>
    <AddSvg className="fill-[#00A32E80]"></AddSvg>
  </div>;
};

const ImageCom = ({detail, onDelete = () => {}}) => {
  return <div className='relative group overflow-hidden flex flex-col justify-between items-center w-[100px] h-[100px] bg-[#082C11] border border-[#00A32E80] rounded-xl'>
    <div className='p-2 h-[75px] cursor-pointer'>
      <img src={detail.url} data-imginfo={JSON.stringify(detail)} className='h-full' draggable></img>
    </div>
    <div className='w-full bg-[#00A32E26] px-2.5 h-[25px] leading-[25px] text-[10px]'>
      Pro_img {detail.id}
    </div>
    <DeleteSvg onClick={onDelete} className="absolute top-1.5 right-1.5 hidden group-hover:block fill-[#E83D3D] cursor-pointer"></DeleteSvg>
  </div>;
};

const TableBox = ({isPre = false, onUpload = () => {} }, ref) => {
  const [ curRowCol, setCurRowCol ] = useState([-1, -1]);
  const [ imgAry, setImgAry ] = useState([]);
  const [ show, setShow ] = useState(false);
  const { rowCol } = useRoot();
  const { row, col } = rowCol;
  const [goodsSize, setGoodsSize] = useState({
    width: 100,
    height: 100,
    
    totalW: 600,
    barH: 30, 
    rowPT: 40,
    rowPB: 4
  });
  const boxRef = useRef(null);

  const fnEmptyImgAry = useCallback(() => {
    const arr = Array.from({ length: row }, () => Array(col).fill(0));
    setImgAry(arr);
  },[row, col]);

  useEffect(() => {
    if(!isPre) {
      fnEmptyImgAry();
    }
  }, [fnEmptyImgAry, isPre]);

  useEffect(() => {
    if(boxRef.current) {
      setTimeout(() => {
        const domObj = document.querySelector('#table_box_1');
        const height = domObj?.offsetHeight ?? 600;

        const offsetWidth = height;
        const offsetHeight = height - 50;

        let goodsHeight = 100;
        let goodsWidht = 100;

        let totalW = 600;
        let barH = 30;
        let rowPT = 30;
        let rowPB = 4;

        let imgXt = 4;

        let rate = 0.7;

        // when row/col >= 7, row box padding-bottom is 0,
        if(row >= 7 || col >= 7 ) {
          rowPB = 0;
        }

        // when row > 3, The calculation of width and height is determined by the screen height.
        if(row > 3) {
          const totalPB = row * rowPB;
          const average =  (offsetHeight - totalPB) / row;
          goodsHeight = average * rate;
          rowPT = average - goodsHeight; 
          barH = rowPT * 0.75;
        } else {

          // when row <=3 and col >= 5, The calculation of width and height is determined by the screen width.
          if(col >= 5) {
            const totalPx = imgXt * col;
            goodsHeight = (offsetWidth - totalPx) / col;
          } else {
            goodsHeight = 100;
          }

          const average =  goodsHeight / rate;
          rowPT = average - goodsHeight; 
          barH = rowPT * 0.75;
        }

        goodsWidht = goodsHeight;
        totalW = col * (goodsWidht + imgXt) + 40;

        setGoodsSize({
          width: goodsWidht,
          height: goodsHeight,

          totalW,
          rowPT,
          barH,
          rowPB
        });

        setShow(true);
      }, 0);
    }
  }, [boxRef.current, col, row]);

  const fnHandler = useCallback((type, rowIndex, colIndex) => {
    const tempAry = JSON.parse(JSON.stringify(imgAry));
    let { img = '', zoom = 1, id } = tempAry[rowIndex][colIndex];
    if(type === 'zoomin') {
      if(zoom < 1) {
        zoom += 0.02;
      }
    } else if(type === 'zoomout') {
      if(zoom > 0.3) {
        zoom -= 0.02;
      }
      if(zoom < 0.3) {
        zoom = 0.3;
      }
    } else if(type === 'remove') {
      img = '';
      zoom = 1;
    } else if(type === 'switch') {
      setCurRowCol([rowIndex, colIndex]);
    }
    if(img === '') {
      tempAry[rowIndex][colIndex] = 0;
    } else {
      tempAry[rowIndex][colIndex] = {
        img,
        id,
        zoom
      };
    }
    setImgAry(tempAry);
  }, [imgAry]);

  const fnDrop = useCallback((type, rowIndex, colIndex, imgData) => {
    const tempAry = JSON.parse(JSON.stringify(imgAry));
    const [oldRowIndex, oldColIndex] = curRowCol;

    if(oldRowIndex < 0 || oldColIndex < 0) {
      const imgDataObj = JSON.parse(imgData);
      // 新增
      tempAry[rowIndex][colIndex] = {
        img: imgDataObj.url,
        id: imgDataObj.id,
        zoom: 1
      };
      setImgAry(tempAry);
      return;
    }
    // 同一个位置
    let curImgObj = tempAry[rowIndex][colIndex];
    let oldImgObj = tempAry[oldRowIndex][oldColIndex];
    if(oldRowIndex === rowIndex && oldColIndex === colIndex) {
      return;
    }
    if(curImgObj !== 0) {
      let tempObj = curImgObj;
      curImgObj = oldImgObj;
      oldImgObj = tempObj;
    } else {
      // 当前 img 为空， 表示 换位置
      curImgObj = oldImgObj;
      oldImgObj = 0;
    }
    tempAry[rowIndex][colIndex] = curImgObj;
    tempAry[oldRowIndex][oldColIndex] = oldImgObj;
    setImgAry(tempAry);
    setCurRowCol([-1, -1]);
  }, [imgAry, curRowCol]);

  const fnImportImg = useCallback((rowIndex, colIndex, imgList) => {
    const tempAry = JSON.parse(JSON.stringify(imgAry));
    const rowLeng = tempAry.length;
    const colLeng = tempAry[0].length;
    let isError = false;
    const total = rowLeng * colLeng;
    if( total < imgList.length) {
      isError = true;
    } else {
      const curNum = (rowIndex * colLeng) + colIndex;
      let hasImgNum = 0;
      for(let i= rowIndex; i < rowLeng; i++) {
        for(let j= colIndex; j < colLeng; j++) {
          if(tempAry[i][j] !== 0) {
            hasImgNum++;
          }
        }
      }
      if((total - curNum - hasImgNum) < imgList.length) {
        isError = true;
      } else {
        isError = false;
      }
    }
    if(isError) {
      message.error('The number of images is greater than the current available space, please try uploading on the left Gallery.');
    } else {
      let index = 0;
      for(let i = rowIndex; i < rowLeng; i++) {
        for(let j = 0; j < colLeng; j++) {
          if(i === rowIndex && j < colIndex) {
            continue;
          }
          if(index < imgList.length) {
            if(tempAry[i][j] === 0) {
              tempAry[i][j] = {
                img: imgList[index].url,
                id: imgList[index].id,
                zoom: 1
              };
            }
          } else {
            break;
          }
          index++;
        }
      }
      setImgAry(tempAry);
    }
  }, [imgAry]);

  useImperativeHandle(ref, () => ({
    imgAry: imgAry,
    cleanAll() {
      fnEmptyImgAry();
    },
    setOldLayout(oldLayout) {
      setImgAry(oldLayout);
    },
    addNew(rowIndex, colIndex, imgData) {
      fnDrop('', rowIndex, colIndex, imgData);
    },
    thirdImportImg(rowIndex, colIndex, imgDatas) {
      fnImportImg(rowIndex, colIndex, imgDatas);
    }
  }));

  return <div ref={boxRef} className='min-w-[700px] mx-auto h-full flex flex-col justify-center items-center' style={{userSelect: 'none'}}>
    {
      show &&  (new Array(row).fill(1)).map((rowItem, rowIndex) => <div key={rowIndex} style={{width: goodsSize.totalW, paddingTop: goodsSize.rowPT + 'px', paddingBottom: goodsSize.rowPB + 'px'}} className='row flex justify-center items-end relative  mx-auto'>
        <img src={BodyLayoutPng} style={{width: goodsSize.totalW + 'px'}} className='h-full absolute top-0 left-0'></img>
        {
          rowIndex === 0 ?  <img src={HeaderLayoutPng} style={{width: goodsSize.totalW + 20 + 'px', maxWidth: goodsSize.totalW + 20 + 'px', height: goodsSize.barH + 'px' }} className='ml-[-10px] w-full absolute top-0 left-0'></img> : <></>
        }
        {
          (new Array(col).fill(1)).map((colItem, colIndex) => <GoodsItem onUpload={() => onUpload(rowIndex, colIndex)} onDrop={(type, imgData) => fnDrop(type, rowIndex, colIndex, imgData)} onHandler={(type) => fnHandler(type, rowIndex, colIndex)} imgInfo={isPre ? {} : imgAry[rowIndex][colIndex]} key={colIndex} width={goodsSize.width} height={goodsSize.height}></GoodsItem>)
        }
        <img src={BottomLayoutPng} style={{width: goodsSize.totalW + 20 + 'px', maxWidth: goodsSize.totalW + 20 + 'px', height: goodsSize.barH + 'px', bottom: - goodsSize.barH + 'px' }} className='ml-[-10px] absolute left-0 z-10'></img>
      </div>)
    }
  </div>;
};
export const TableBoxView = forwardRef(TableBox);

const GoodsItem = ({width, height, imgInfo, onHandler = () => {}, onDrop = () => {}, onUpload = () => {}}) => {
  const { img: url = '', zoom = 1 } = imgInfo;
  // const newWidth = width * zoom;
  const newWidth = height * zoom;

  const fnDragEnter = (event) => {
    let curTarget = event.target;
    if(curTarget.classList.contains('dropzone-66')) {
      curTarget.classList.add('border');
      curTarget.classList.add('border-[#00A32E]');
    }
  };

  const fnDragLeave = (event) => {
    if (event.target.classList.contains('dropzone-66')) {
      event.target.classList.remove('border');
      event.target.classList.remove('border-[#00A32E]');
    }
  };

  const fnDrop = (event) => {
    onDrop('drop', event.dataTransfer.getData('text/plain'));
    if (event.target.classList.contains('dropzone-66')) {
      event.target.classList.remove('border');
      event.target.classList.remove('border-[#00A32E]');
    }
  };

  const fnDragStart = () => {
    onHandler('switch');
  };

  const fnUpload = () => {
    if(!url) {
      onUpload();
    }
  };
  
  return <>
    <div style={{height: height + 'px', width: url ? 'fit-content' : `${width}px`, backgroundColor: url ? 'transparent' : '#24402C29'}} onDrop={fnDrop} onDragEnter={fnDragEnter} onDragLeave={fnDragLeave} onDragOver={(event) => event.preventDefault()} onClick={fnUpload} className={`dropzone-66 cursor-pointer group mx-[2px] flex justify-center ${url ? 'items-end' : 'items-center'} relative`}>
      {
        // style={{height: newWidth + 'px', transform: 'translate(-50%, 0%)', maxWidth: 'unset'}} className=' absolute bottom-0 left-[50%] z-10'
        url ? <img onDragStart={fnDragStart} src={url} style={{height: newWidth + 'px'}} className=' relative z-10'></img> :
          <AddSvg className="fill-[#24402C] w-3"></AddSvg>
      }
      {
        url && <div className='hidden group-hover:flex flex-col items-center justify-center p-2.5 rounded bg-[#00A32E] absolute left-[-37px] z-30 top-[50%]' style={{transform: 'translate(0, -50%)'}}>
          <ZoomInSvg onClick={() => onHandler('zoomin')} className=" cursor-pointer fill-white hover:text-[#013B02]"></ZoomInSvg>
          <div className='my-2.5 h-[2px] w-[130%] bg-[#D9D9D985]'></div>
          <ZoomOutSvg onClick={() => onHandler('zoomout')} className=" cursor-pointer fill-white hover:text-[#013B02]"></ZoomOutSvg>
          <div className='my-2.5 h-[2px] w-[130%] bg-[#D9D9D985]'></div>
          <RemoveSvg onClick={() => onHandler('remove')} className=" cursor-pointer fill-white hover:text-[#013B02]"></RemoveSvg>
        </div>
      }
    </div>
  </>;
};

const CanvasTableBox = ({aryData = []}) => {
  const { rowCol } = useRoot();
  const { row, col } = rowCol;
  const [ imgUrl, setImgUrl] = useState({});
  const [ isPaint, setIsPaint ] = useState(false);
  const [goodsSize, setGoodsSize] = useState({
    width: 100,
    height: 100,
    
    totalW: 600,
    barH: 30, 
    rowPT: 40,
    rowPB: 4
  });

  const fnGetImgurl = useCallback(async() => {
    setIsPaint(false);
    const ids = [];
    aryData.forEach(rowItem => {
      rowItem.forEach(colItem => {
        if(colItem !== 0) {
          ids.push(colItem.id);
        }
      });
    });
    if(ids.length>0) {
      const result = await getImageurl({image_ids: ids});
      if(result.status === 'Success') {
        const imgUrlObj = {};
        result.data.forEach(item => {
          imgUrlObj[item.id] = item.url;
        });
        setImgUrl(imgUrlObj);
        setIsPaint(true);
      }
    }
  }, [aryData]);

  useEffect(()=> {
    fnGetImgurl();
  }, [fnGetImgurl]);

  useEffect(() => {
    setTimeout(() => {
      const domObj = document.querySelector('#goods_layout_id');
      const height = domObj?.offsetHeight ?? 600;

      const offsetWidth = height;
      const offsetHeight = height - 50;

      let goodsHeight = 100;
      let goodsWidht = 100;

      let totalW = 600;
      let barH = 30;
      let rowPT = 30;
      let rowPB = 4;

      let imgXt = 4;

      let rate = 0.7;

      // when row/col >= 7, row box padding-bottom is 0,
      if(row >= 7 || col >= 7 ) {
        rowPB = 0;
      }

      // when row > 3, The calculation of width and height is determined by the screen height.
      if(row > 3) {
        const totalPB = row * rowPB;
        const average =  (offsetHeight - totalPB) / row;
        goodsHeight = average * rate;
        rowPT = average - goodsHeight; 
        barH = rowPT * 0.75;
      } else {

        // when row <=3 and col >= 5, The calculation of width and height is determined by the screen width.
        if(col >= 5) {
          const totalPx = imgXt * col;
          goodsHeight = (offsetWidth - totalPx) / col;
        } else {
          goodsHeight = 100;
        }

        const average =  goodsHeight / rate;
        rowPT = average - goodsHeight; 
        barH = rowPT * 0.75;
      }

      goodsWidht = goodsHeight;
      totalW = col * (goodsWidht + imgXt) + 40;

      setGoodsSize({
        width: goodsWidht,
        height: goodsHeight,

        totalW,
        rowPT,
        barH,
        rowPB
      });
    }, 0);
  }, [col, row]);

  return aryData.length && isPaint ?  <div className='fixed h-full w-full flex justify-center items-center top-[-1000000px] left-[-1000000px] z-30'>
    <div id="goods_layout_id" className='min-w-[700px] mx-auto h-full flex flex-col justify-center items-center'>
      {
        aryData.map((rowItem, rowIndex) => <div key={rowIndex} style={{width: goodsSize.totalW, paddingTop: goodsSize.rowPT + 'px', paddingBottom: goodsSize.rowPB + 'px'}} className='row flex justify-center items-end relative  mx-auto'>
          <img src={BodyLayoutPng} style={{width: goodsSize.totalW + 'px'}} className='h-full absolute top-0 left-0'></img>
          {
            rowIndex === 0 ?  <img src={HeaderLayoutPng} style={{width: goodsSize.totalW + 20 + 'px', maxWidth: goodsSize.totalW + 20 + 'px', height: goodsSize.barH + 'px' }} className='ml-[-10px] w-full absolute top-0 left-0'></img> : <></>
          }
          {
            rowItem.map((colItem, colIndex) => <CanvasGoodsItem key={colIndex} imgUrlObj={imgUrl} imgInfo={colItem} width={goodsSize.width} height={goodsSize.height}></CanvasGoodsItem>)
          }
          <img src={BottomLayoutPng} style={{width: goodsSize.totalW + 20 + 'px', maxWidth: goodsSize.totalW + 20 + 'px', height: goodsSize.barH + 'px', bottom: - goodsSize.barH + 'px' }} className='ml-[-10px] absolute left-0 z-10'></img>
        </div>)
      }
    </div>;
  </div> : <></>;
};

const CanvasGoodsItem = ({width, height, imgInfo, imgUrlObj = {}}) => {
  let { img: url = '', id = '', zoom = 1 } = imgInfo;
  const newWidth = height * zoom;
  if(url) {
    url = imgUrlObj[id];
  }

  return <>
    <div style={{height: height + 'px', width: url ? 'fit-content' : `${width}px`, backgroundColor: 'transparent'}} className={`dropzone-66 cursor-pointer group mx-[2px] flex justify-center ${url ? 'items-end' : 'items-center'} relative`}>
      {
        url ? <img src={url} style={{height: newWidth + 'px'}} className=' relative z-10'></img> :
          <div></div>
      }
    </div>
  </>;
};

export default GenerateLayout;